export default __webpack_public_path__ + "static/media/36.116d9cd1.png";